export class GTMService {
    static pushToDataLayer(events) {
        window.dataLayer = (typeof window.dataLayer != 'undefined' && window.dataLayer instanceof Array) ? window.dataLayer : [];
        window.dataLayer.push(...events);
    }
}